var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"huetiful-window",class:{minimized: _vm.minimized, bordered: _vm.bordered, inset: _vm.inset},style:({'background-color': _vm.color}),on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }